import React from 'react';
import SubHeader from '../SubHeader';
import NotesSection from './Notes';
import ResponseDocumentation from './ResponseDocumentation';

export default class Response extends React.Component {
  render() {
    const { response, user, handleFileSelect, handleFileRemove, handleNotesChange } = this.props;

    if (!response) return null;
    if (user.isInspector()) return null;

    return (
      <React.Fragment>
        <SubHeader label='Variation Response' number='2' />
        <NotesSection notes={response.notes} user={user} handleNotesChange={handleNotesChange} />
        <ResponseDocumentation
          varDocuments={[...(response.varDocuments || [])]}
          error={response.error}
          status={response.status}
          user={user}
          handleFileSelect={handleFileSelect}
          handleFileRemove={handleFileRemove}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Edit/Response/index.jsx